import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../Payday";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by jonas on 2022-09-02.
 */

export class ResetClaws implements SimplePresentation {

    name:string = "ResetClaws";

    constructor() {
    }

    public shouldRun():boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1, false)
            });
        });

        const bruh = Payday.reelView.resetClaws();
        if (bruh.some((tween) => tween.duration() > 0)) {
            tl.add(() => {
                Payday.soundPlayer.playSound("clawMoving")
            })
            tl.add(bruh, '<');
            tl.add(() => {
                Payday.soundPlayer.stopSound("clawMoving")
                Payday.soundPlayer.playSound("clawMovingStop")
            }, bruh.filter((tween) => tween.duration() > 0)[0].duration() - 0.125) // gsap breaks if timing was set to play 0.125 from end of last animation
            if (Payday.apiPlugin.settings.get(APISetting.FAST_SPIN))
                tl.timeScale(2);
        }

        tl.add(() => {
            controller.finish();
        })
    }
}